import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ConfigSystemParams, msSize } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-images-modal-form',
  templateUrl: './images-modal-form.component.html',
  styleUrls: ['./images-modal-form.component.scss']
})

export class ImagesModalFormComponent implements AfterViewInit, OnInit {

  @ViewChild('imageModalFormContent', { static: false }) imageModalFormContent!: TemplateRef<void>;
    
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }

  private images       : Array<string>=[];

  public imageLink     : string="";
  public imageNumbering: string="";
  public imageUrl      : string="";
  public mainMessage   : string | undefined;
  public maxIndex      : number=0;
  public selectedIndex : number=0;
  public subMessage    : string | undefined;

  constructor(
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService,
    private modalService       : NgbModal
  ) {

  }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetForm(): void {
    try {
      this.selectedIndex=0;
      this.images       =[];

      //#region images
      
      this.images.push("https://cdn.lordicon.com/adwosptt.json");
      this.images.push("https://cdn.lordicon.com/auvicynv.json");
      this.images.push("https://cdn.lordicon.com/aydxrkfl.json");
      this.images.push("https://cdn.lordicon.com/ayjfxoly.json");
      this.images.push("https://cdn.lordicon.com/cnyeuzxc.json");
      this.images.push("https://cdn.lordicon.com/cvwrvyjv.json");
      this.images.push("https://cdn.lordicon.com/dklbhvrt.json");
      this.images.push("https://cdn.lordicon.com/dicvhxpz.json");
      this.images.push("https://cdn.lordicon.com/ebvizisb.json");
      this.images.push("https://cdn.lordicon.com/edcgvlnw.json");
      this.images.push("https://cdn.lordicon.com/etwtznjn.json");
      this.images.push("https://cdn.lordicon.com/exymduqj.json");
      this.images.push("https://cdn.lordicon.com/fqbvgezn.json");
      this.images.push("https://cdn.lordicon.com/fcyboqbm.json");
      this.images.push("https://cdn.lordicon.com/fhtaantg.json");
      this.images.push("https://cdn.lordicon.com/fjvfsqea.json");
      this.images.push("https://cdn.lordicon.com/ggirntso.json");
      this.images.push("https://cdn.lordicon.com/gsqxdxog.json");
      this.images.push("https://cdn.lordicon.com/hfmdczge.json");
      this.images.push("https://cdn.lordicon.com/hrqwmuhr.json");
      this.images.push("https://cdn.lordicon.com/hzomhqxz.json");
      this.images.push("https://cdn.lordicon.com/itykargr.json");
      this.images.push("https://cdn.lordicon.com/iuteewri.json");
      this.images.push("https://cdn.lordicon.com/jectmwqf.json");
      this.images.push("https://cdn.lordicon.com/jeuxydnh.json");
      this.images.push("https://cdn.lordicon.com/kbtmbyzy.json");
      this.images.push("https://cdn.lordicon.com/kkcllwsu.json");
      this.images.push("https://cdn.lordicon.com/lupuorrc.json");
      this.images.push("https://cdn.lordicon.com/msoeawqm.json");
      this.images.push("https://cdn.lordicon.com/nkmsrxys.json");
      this.images.push("https://cdn.lordicon.com/nvsfzbop.json");
      this.images.push("https://cdn.lordicon.com/oclwxpmm.json");
      this.images.push("https://cdn.lordicon.com/ogjpwrxe.json");
      this.images.push("https://cdn.lordicon.com/onmwuuox.json");
      this.images.push("https://cdn.lordicon.com/pvbjsfif.json");
      this.images.push("https://cdn.lordicon.com/pxwxddbb.json");
      this.images.push("https://cdn.lordicon.com/qhviklyi.json");
      this.images.push("https://cdn.lordicon.com/rahcoaeu.json");
      this.images.push("https://cdn.lordicon.com/rhmbrqqg.json");
      this.images.push("https://cdn.lordicon.com/rhvddzym.json");
      this.images.push("https://cdn.lordicon.com/rpviwvwn.json");
      this.images.push("https://cdn.lordicon.com/rszslpey.json");
      this.images.push("https://cdn.lordicon.com/rypcsrlk.json");
      this.images.push("https://cdn.lordicon.com/sbnjyzil.json");
      this.images.push("https://cdn.lordicon.com/shcfcebj.json");
      this.images.push("https://cdn.lordicon.com/smauprql.json");
      this.images.push("https://cdn.lordicon.com/sygggnra.json");
      this.images.push("https://cdn.lordicon.com/tdrtiskw.json");
      this.images.push("https://cdn.lordicon.com/tsrgicte.json");
      this.images.push("https://cdn.lordicon.com/tqywkdcz.json");
      this.images.push("https://cdn.lordicon.com/ucvsemjq.json");
      this.images.push("https://cdn.lordicon.com/uetqnvvg.json");
      this.images.push("https://cdn.lordicon.com/vaeagfzc.json");
      this.images.push("https://cdn.lordicon.com/wghpqwxd.json");
      this.images.push("https://cdn.lordicon.com/wsaaegar.json");
      this.images.push("https://cdn.lordicon.com/xhebrhsj.json");
      this.images.push("https://cdn.lordicon.com/xulniijg.json");
      this.images.push("https://cdn.lordicon.com/yeallgsa.json");
      this.images.push("https://cdn.lordicon.com/ypnsnhgh.json");
      this.images.push("https://cdn.lordicon.com/zpxybbhl.json");

      //#endregion

      this.maxIndex=this.images.length-1;

      this.setImage();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(mainMessage: string/*, subMessage: string*/): void {
    try {
      this.resetForm();
      this.mainMessage=mainMessage != undefined && mainMessage.trim() != "" ? mainMessage : "Main Warning Message not set";
      //this.subMessage =subMessage  != undefined && subMessage.trim()  != "" ? subMessage  : "Sub Warning Message not set";

      this.modalService.open(this.imageModalFormContent, { backdrop     : this.modalBackGround,
                                                           backdropClass: 'popup-on-top-backdrop',
                                                           centered     : true,
                                                           container    : 'body',
                                                           keyboard     : false,
                                                           size         : msSize.Small,
                                                           windowClass  : 'popup-on-top' });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public previousClick(): void {
    try {
      this.selectedIndex -= 1;
      this.setImage();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public nextClick(): void {
    try {
      this.selectedIndex += 1;
      this.setImage();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setImage(): void {
    try {
      this.imageLink     =this.images[this.selectedIndex];
      this.subMessage    =this.imageLink;
      this.imageNumbering=<string><unknown>(this.selectedIndex+1) + " of " + <string><unknown>(this.maxIndex+1);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
